import { IsBoolean } from 'class-validator';

export class PublicProfileActivityUpdateModel {
  @IsBoolean()
  public active: boolean;

  constructor(
    active: boolean
  ) {
    this.active = active;
  }
}
